export const SHARED_QUOTECART_TABLE = {
    header: {},
    options: {
      spacing: 'medium',
      paginationMode: 'auto',
      hideCellVerticalBorder: false,
      
    },
    schema: [
      {
        label: 'Cart name',
        prop: 'name',
        option: {
          width: 100,
        },
        html: {
          template: `
          <div style="display: flex; justify-content: left; align-items: left;">
          <bh-a type="primary" font="typography--body-medium" text="{0}"  href="javascript:void(0)"></bh-a></div>`,
          keys: ['name'],
          events: [
            { type: 'click', func: `changes($event)` }]
        }
      },
      {
        label: 'ID',
        prop: 'code',
        option: {
          width: 100,
        },
      },
      {
        label: 'Date saved',
        prop: 'saveTime',
        option: {
          isSortable: true,
          width: 120,
        },
      },
      {
          label: 'Created by',
          prop: 'savedByName',
          option: {
            isSortable: true,
            width: 120,
          },
        },
      {
        label: 'Description',
        prop: 'description',
        option: {
          width: 120,
        },
      },
      {
        label: 'Estimated total',
        prop: 'estimatedTotal',
        option: {
          isSortable: true,
          width: 150,
        },
      },
      {
        label: 'Expiry date',
        prop: 'expirationTime',
        option: {
          isSortable: true,
          width: 100,
        },
      },
      {
          label: 'Last modified',
          prop: 'restoredTime',
          option: {
            isSortable: true,
            width: 150,
          },
        },
        {
          label: 'Modified by',
          prop: 'restoredUserName',
          option: {
            isSortable: true,
            width: 150,
          },
        },
        {
          label: 'Actions',
          html: {
              template: `<div class='d-flex justify-content-between'>
              <bh-icon icon="date_range" size="small" color="secondary" href="" target=""></bh-icon>
              <bh-icon icon="shopping_cart_checkout" size="small" color="secondary" href="" target=""></bh-icon>
              <bh-icon icon="delete" size="small" color="secondary" href="" target=""></bh-icon>
              </div>`,
              events: [
                  { type: 'click', func: `changes($event)` }]
            },
          option: {
            isSortable: true,
            width: 100,
          },
        },
  
    ],
    payload: {
      data: [],
      length: 0,
    },
  };